"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getFieldSchemaName = (name = '') => {
    let clearedName = name.replace(/\[\d+\]/g, '');
    if (/\.?([^.]+)$/.test(clearedName)) {
        clearedName = RegExp.$1;
    }
    return clearedName;
};
exports.getFieldSchemaName = getFieldSchemaName;
//# sourceMappingURL=getFieldSchemaName.js.map